import React from 'react';
import { combinedPredictionBands } from './combinedPredictionBands';
import './w51-combined-predictions.css';

const PredictionSlot = ({ entry }) => (
  <div className="w51-combined-slot" data-testid={`w51-combined-p${entry.rank}`}>
    <span className="w51-combined-rank" data-testid={`w51-combined-p${entry.rank}-rank`}>P{entry.rank}</span>
    <span className={`w51-combined-number ${entry.number == null ? 'w51-combined-missing' : ''}`} data-testid={`w51-combined-p${entry.rank}-number`}>
      {entry.number ?? '—'}
    </span>
    {entry.number == null && <span className="w51-combined-status" data-testid={`w51-combined-p${entry.rank}-status`}>{entry.state === 'not-issued' ? 'Not issued' : 'Unavailable'}</span>}
  </div>
);

export const W51CombinedPredictions = ({ predictions, currentDraw, nextDraw, historical }) => {
  const { available, bands, additional, issuedCount } = combinedPredictionBands(predictions);
  const source = Number.isInteger(currentDraw?.draw_number) ? currentDraw.draw_number : null;
  const target = Number.isInteger(nextDraw?.draw_number) ? nextDraw.draw_number : source == null ? null : source + 1;
  return <section className="w51-combined-predictions" aria-labelledby="w51-combined-title" data-testid="w51-combined-predictions">
    <div className="w51-combined-heading">
      <div>
        <h2 id="w51-combined-title" data-testid="w51-combined-title">Combined Predictions</h2>
        <p data-testid="w51-combined-draw-context">{historical ? 'Historical calculation' : 'Next draw'}{target == null ? '' : ` · #${target}`} · Based on #{source ?? '—'}{currentDraw?.draw_date ? ` · ${currentDraw.draw_date}` : ''}</p>
      </div>
      <span className="w51-combined-issued" data-testid="w51-combined-issued">{available ? `${issuedCount} issued numbers` : 'Prediction data unavailable'}</span>
    </div>
    <div className="w51-combined-bands" data-testid="w51-combined-bands">
      {bands.map(band => <article key={band.label} className="w51-combined-band" data-testid={`w51-combined-${band.label.toLowerCase()}`}>
        <div className="w51-combined-band-heading">
          <h3 data-testid={`w51-combined-${band.label.toLowerCase()}-label`}>{band.label}</h3>
          <span data-testid={`w51-combined-${band.label.toLowerCase()}-range`}>P{band.start}–P{band.end}</span>
        </div>
        <div className="w51-combined-band-numbers">{band.entries.map(entry => <PredictionSlot key={entry.rank} entry={entry} />)}</div>
      </article>)}
    </div>
    {additional.length > 0 && <div className="w51-combined-additional" data-testid="w51-combined-additional">
      <p data-testid="w51-combined-additional-label">Additional issued ranks · P21{additional.length > 1 ? `–P${20 + additional.length}` : ''}</p>
      <div>{additional.map(entry => <PredictionSlot key={entry.rank} entry={entry} />)}</div>
    </div>}
    {available && issuedCount === 0 && <p className="w51-combined-note" data-testid="w51-combined-empty">No valid number predictions are available for this draw.</p>}
    <p className="w51-combined-note" data-testid="w51-combined-source">Existing W51 combined number ranking · Exclusive bands · Main numbers 1–50</p>
  </section>;
};
